export const LIMITS = {
  ROOM_NAME_MAX: 30,
  DEFAULT_ROOM_NAME: '오늘의 점심 메뉴',
  NICKNAME_MIN: 2,
  NICKNAME_MAX: 12,
  PARTICIPANTS_MIN: 1,
  PARTICIPANTS_MAX: 20,
  DEFAULT_PARTICIPANTS: 4,
  PASSWORD_MIN: 4,
  PASSWORD_MAX: 32,
  ROOM_ID_LENGTH: 16,
} as const;

/** 시간 관련 설정 (ms) */
export const TIMING = {
  /** 정원 충족 후 게임 시작까지 대기 (시작 애니메이션 시간) */
  START_DELAY_MS: 3_000,
  /** 현재 선택 담당자 연결 끊김 유예 시간 */
  CHOOSER_GRACE_MS: 30_000,
  /** 대기실에서 연결 끊긴 참여자를 제거하기까지의 유예 시간 */
  LOBBY_DISCONNECT_GRACE_MS: 20_000,
  /** 대기 중 방 만료: 생성 후 */
  EXPIRE_WAITING_MS: 60 * 60 * 1000,
  /** 진행 중 방 만료: 마지막 활동 후 */
  EXPIRE_PLAYING_MS: 2 * 60 * 60 * 1000,
  /** 완료 후 방 만료: 마지막 활동 후 */
  EXPIRE_COMPLETED_MS: 60 * 60 * 1000,
  /** 랜덤 선택 애니메이션 길이 */
  RANDOM_REVEAL_MS: 1_600,
  /** 일반 선택 하이라이트 길이 */
  SELECT_REVEAL_MS: 700,
} as const;

/** WebSocket 종료 코드 (4000번대: 재접속하지 않음) */
export const WS_CLOSE = {
  ROOM_CLOSED: 4000,
  UNAUTHORIZED: 4001,
  KICKED: 4002,
  REPLACED: 4003,
  LEFT: 4004,
  RATE_LIMITED: 4008,
} as const;
